<template>
	<ul class="nav smenu">
		<slot></slot>
	</ul>
</template>

<script>
	export default {
		props: {
			content: String,
			close: Boolean,
			type: String,
			position: String
		},
		data() {
			return {}
		},
		methods: {
			handleClose(event) {
				this.$emit('close', event);
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			seType() {
				return this.type ? "alert-" + this.type : 'alert-warning';
			},
			setPosition() {
				return this.position ? "fixed fix" + this.position : "";
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.smenu {
		>li {
			>a {
				color: @cc2;
				.pd(@mpb 6*@mpb @mpb 2*@mpb);
				cursor: pointer;
				background-color:@nbgc;
				.iconfont {
					.mgr(@mpb/3);
				}
				&:hover {
					background-color: @nbg;
					color: @cwh;
				}
				.label,
				.badge {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: initial;
					right: 4*@mpb;
				}
				&:not(:only-child) {
					&:before {
						font-family: "iconfont" !important;
						font-style: normal;
						content: "\e62a";
						position: absolute;
						.trs(@t: .3s);
						top: 50%;
						right: 1.5*@mpb;
						transform: translateY(-50%) rotate(0);
						font-size: 24px;
					}
				}
			}
			&.router-link-active {
				a {
					&:not(:only-child) {
						&:before {
							transform: translateY(-50%) rotate(90deg);
						}
					}
				}
			}
			&.router-link-active .smenu {
				height: auto;
				a{
					color: @cc2;
					&:hover{
						color:@cwh;
					}
				}
				li.router-link-active{
					a{
						color: @cwh;
						border-color: @cre;
					}
				}
			}
			.smenu {
				height: 0;
				.trs;
				.ohd;
				a {
					color: initial;
					.pdl(3.1*@mpb);
					&:only-child {
						content: "";
					}
				}
			}
		}
		li {
			a {
				.bdrl(@cr: @nbg, @w: 3px);
			}
			&.router-link-active {
				a {
					background-color: @nbg;
					color: @cwh;
					border-color: @cgr;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// smenu.vue?40816521